export default {
  model (resource) {
    return Object.assign({
      firstName: '',
      lastName: '',
      company: '',
      street: '',
      outdoor: '',
      indoor: '',
      zipCode: '',
      state: '',
      municipality: '',
      country: '',
      neighborhood: '',
      phone: '',
      mobile: '',
      workPhone: '',
      workExtension: '',
      favourite: false,
      userId: null
      /*      activityId: null,
      customerId: null,
      surface: null */
    }, resource)
  },
  rules () {
    return {
      lastName: [
        {required: true, message: 'Los apellidos son requeridos'},
        {min: 2, max: 255, message: 'Los apellidos deben contener entre 2 y 255 carácteres'}
      ],
      firstName: [
        {required: true, message: 'El nombre es requerido'},
        {min: 2, max: 255, message: 'El nombre debe contener entre 2 y 255 carácteres'}
      ],
      street: [
        {required: true, message: 'El nombre de la calle es requerido'},
        {min: 1, max: 255, message: 'El nombre de la calle debe ser entre 5 y 255 carácteres'}
      ],
      company: [
        {required: true, message: 'La compañía es requerida'},
        {min: 2, max: 255, message: 'La compañía debe contener entre 2 y 255 carácteres'}
      ],
      outdoor: [
        {required: true, message: 'El número exterior es requerido'},
        {min: 1, max: 4, message: 'El número de la calle debe ser entre 1 y 4 carácteres'}
      ],
      neighborhood: [
        {required: true, message: 'La colonia es requerida'},
        {min: 1, max: 255, message: 'La colonia materno debe ser entre 1 y 255 carácteres'}
      ],
      zipCode: [
        {
          required: true,
          message: 'Seleccione un codigo postal o escribalo'
        },
        {min: 5, max: 5, message: 'El código postal debe ser de 5 carácteres'}
      ],
      email: [
        {
          required: true,
          message: 'Ingrese un correo electrónico valido',
          type: 'email'
        }
      ],
      phone: [
        {
          required: true,
          message: 'Ingrese un número de telefono valido'
        },
        {min: 10, max: 10, message: 'El telefono debe contener minimo 10 caracteres'}
      ],
      mobile: [
        {
          required: true,
          message: 'Ingrese un número de telefono valido'
        },
        {min: 10, max: 10, message: 'El número de celular debe contener minimo 10 caracteres'}
      ],
      /* workNumber: [
        {
          required: true,
          message: 'Ingrese un número de teléfono valido'
        },
        {min: 10, max: 10, message: 'El número de teléfono debe contener minimo 10 caracteres'}
      ], */
      activityId: {
        required: true,
        message: 'Seleccione una actividad'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/customers/customers-model.js